$(function () {
    initEvents();
    initCalendar();
    initValidation();
    applyMasks(true);

    $('.select2').select2();
});

$('#SchoolId').change(function () {
    var selectedSchoolId = this.value;
    var url = '/api/home/ProgramRequestSchoolInfo/' + selectedSchoolId;

    $("#SchoolInfo").text("");

    if (selectedSchoolId) {
        $.getJSON(url, function (school) {
            if (school.PhoneNumber) {
                $("#SchoolInfo").append("<small class=\"text-muted\">" + school.PhoneNumber + "</small> </br>");
            }
            if (school.Address) {
                $("#SchoolInfo").append("<small class=\"text-muted\">" + school.Address + "</small>");
            }
        });
    }
});

function initEvents() {
    $('#NumberAdults,#NumberChildren').on('input', function () {
        $('#NumberTotal').val(
            Number($('#NumberAdults').val() || 0) + Number($('#NumberChildren').val() || 0));
    });
}

function initCalendar() {
    $('#DateRequestedCalendar').datepicker({
        format: 'mm/dd/yyyy'
    })
        .on('changeMonth', function (ev) {
            getBlackoutDates($('#DateRequestedCalendar'), moment.utc(ev.date.valueOf()));
        })
        .on('changeDate', function (ev) {
            var dateString = moment.utc(ev.date.valueOf()).format('MM/DD/YYYY');
            $('#dateRequestedLabel').text(dateString);
            $('#DateRequested').val(dateString);
        });

    $('#AlternativeDateRequested').datepicker({
        format: 'mm/dd/yyyy'
    })
        .on('changeMonth', function (ev) {
            getBlackoutDates($('#AlternativeDateRequested'), moment.utc(ev.date.valueOf()));
        });

    $('#DateRequestedCalendar').datepicker('setDaysOfWeekDisabled', daysOfWeekDisabled);
    $('#AlternativeDateRequested').datepicker('setDaysOfWeekDisabled', daysOfWeekDisabled);

    getBlackoutDates($('#DateRequestedCalendar'), moment.utc(), true);
    getBlackoutDates($('#AlternativeDateRequested'), moment.utc(), true);
}

function initValidation() {
    $.validator.addMethod('minDate', function (v, el, minDate) {
        if (this.optional(el)) {
            return true;
        }

        return minDate.setHours(0, 0, 0, 0) <= new Date(v).setHours(0, 0, 0, 0);
    }, 'Date must be in the future.');

    $('#programRequestForm').validate(extendValidationSettings({
        ignore: "",
        rules: {
            DateRequested: {
                required: true,
                minDate: new Date()
            },
            RequestType: {
                required: true
            },
            GroupName: {
                required: function () {
                    return !$("#SchoolId").val();
                },
                minlength: 2,
                maxlength: 50
            },
            SchoolId: {
                required: function () {
                    return doesDisplaySchoolsList && !$("#GroupName").val();
                }
            },
            GroupLeader: {
                required: true,
                minlength: 2,
                maxlength: 50
            },
            NumberAdults: {
                required: true
            },
            NumberChildren: {
                required: true
            },
            ParticipantCount: {
                required: true
            },
            StartTimeRequested: {
                required: true,
                validTime: true
            },
            EndTimeRequested: {
                required: true,
                validTime: true
            },
            AlternativeDateRequested: {
                date: true,
                minDate: new Date()
            }
        },
        messages: {
            DateRequested: {
                required: 'Calendar Date Requested is required. (Available dates are highlighted with green)',
                minDate: 'Calendar Date must not be in the past.'
            },
            RequestType: {
                required: 'Type is required.'
            },
            GroupName: {
                required: function () {
                    if (doesDisplaySchoolsList) {
                        return 'Either School OR Unlisted School / Other Group Name is required.';
                    }
                    else {
                        return 'Group Name is required.';
                    }
                },
                minlength: function () {
                    if (doesDisplaySchoolsList) {
                        return jQuery.validator.format('Unlisted School / Other Group Name must be at least {0} characters.');
                    }
                    else {
                        return jQuery.validator.format('Group Name must be at least {0} characters.');
                    }
                },
                maxlength: function () {
                    if (doesDisplaySchoolsList) {
                        return jQuery.validator.format('Unlisted School / Other Group Name must be less than {0} characters.');
                    }
                    else {
                        return jQuery.validator.format('Group Name must be less than {0} characters.');
                    }
                }
            },
            GroupLeader: {
                required: 'Leader / Teacher is required.',
                minlength: jQuery.validator.format('Leader / Teacher must be at least {0} characters.'),
                maxlength: jQuery.validator.format('Leader / Teacher must be less than {0} characters.')
            },
            NumberAdults: {
                required: 'Number of Adults is required.'
            },
            NumberChildren: {
                required: 'Number of Children is required.'
            },
            StartTimeRequested: {
                required: 'Start Time is required.',
                validTime: 'Start Time must be a valid time.'
            },
            EndTimeRequested: {
                required: 'End Time is required.',
                validTime: 'End Time must be a valid time.'
            },
            AlternativeDateRequested: {
                date: 'Alternative Date must be a valid date.',
                minDate: 'Alternative Date must not be in the past.'
            }
        }
    }));

    if (doesCollectAddress) {
        $('#programRequestForm #Address1').rules('add', {
            required: true,
            messages: {
                required: 'Address is required.'
            }
        });

        $('#programRequestForm #City').rules('add', {
            required: true,
            messages: {
                required: 'City is required.'
            }
        });

        $('#programRequestForm #State').rules('add', {
            required: true,
            messages: {
                required: 'State is required.'
            }
        });

        $('#programRequestForm #ZipCode').rules('add', {
            required: true,
            messages: {
                required: 'Zip Code is required.'
            }
        });
    }
}

function getBlackoutDates(element, date, setDefaultDate) {
    var month = date.format('M');
    var year = date.format('YYYY');

    var url = '/api/Home/ProgramRequestBlackoutDates/' + programRequestTypeId + '?month=' + month + '&year=' + year;

    if (setDefaultDate) {
        url += '&searchForFirstAvailable=true';
    }

    $.getJSON(url, function (data) {
        element.datepicker('setDatesDisabled', data.BlackoutDates);
        if (data.FirstAvailable) {
            var firstAvailable = moment(data.FirstAvailable).toDate();
            element.datepicker('setUTCDate', firstAvailable);
            element.datepicker('update', firstAvailable); //https://github.com/eternicode/bootstrap-datepicker/issues/1980 (must set date or ui will flash back to current month)
        }
        else {
            if (date > moment()) {
                date = date.startOf('month');
            }

            element.datepicker('update', date.format('MM/DD/YYYY')); //https://github.com/eternicode/bootstrap-datepicker/issues/1980 (must set date or ui will flash back to current month)
        }
    });
}